<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getCost,
  getAgentShare,
  add,
  update,
  del,
  getCostItem,
  getShareType,
  getDeliverAddress,
  updateShareSave
} from "@/api/extract/apportion";
import { getAirAgent } from "@/api/tracker/cost_page";
import cTable from "@/base/common/index";
import numFun from "@/utils/numFun";
import { getExpense } from "@/api/finance/expense";
import { getCurrency } from "@/api/finance/currency";
export default {
  props: {
    row: {
      type: Object
    }
  },
  components: {
    cTable
  },

  data() {
    let that = this;
    return {
      totalAmount: [],
      methods: {
        list: p => {
          p.extract_id = this.row.id;
          return getAgentShare(p);
        },
        add,
        update,
        del,
        getExpense,
        getCostItem,
        getShareType,
        getDeliverAddress,
        getCurrency,
        getAirAgent,
        updateShareSave,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          for (const key in data.count) {
            this.totalAmount.push({
              text: this.$t("total"),
              replace_currency: key,
              total_amount: data.count[key]
            });
          }
          return data.rows;
        }
      },
      config: {
        slot: "div",
        resize: false,
        height: 600
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              // let requestType = "add";
              data.extract_id = this.$page.$main.row.id;
              if (row.id) {
                data.id = row.id;
                // requestType = "update";
              }
              this.$page
                .handleRequestMethods("updateShareSave", data, true, false)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              // agent_id: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: this.$t("select") + this.$t("agentName"),
              //     trigger: "change"
              //   }
              // ],
              // expense_item: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: this.$t("select") + this.$t("expense_item_txt"),
              //     trigger: "change"
              //   }
              // ],
              // cost_item: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: this.$t("select") + this.$t("cost_item_txt"),
              //     trigger: "change"
              //   }
              // ],
              // deliver_address: [
              //   {
              //     required: true,
              //     type: "array",
              //     message: this.$t("select") + this.$t("deliver_address_txt"),
              //     trigger: "change"
              //   }
              // ],
              // currency: [
              //   {
              //     required: true,
              //     message: this.$t("select") + this.$t("currencyCode"),
              //     trigger: "change"
              //   }
              // ],
              // cost: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: this.$t("enter") + this.$t("cost"),
              //     trigger: "change"
              //   }
              // ],
              // share_type: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: this.$t("select") + this.$t("share_type_txt"),
              //     trigger: "change"
              //   }
              // ]
            }
          },
          grid: [
            { agent_id: 24 },
            { expense_item: 24 },
            { cost_item: 24 },
            { deliver_address: 24 },
            { currency: 24 },
            { amount: 24 },
            { to_cny_rate: 24 },
            { cny_amount: 24 },
            { share_type: 24 }
          ],
          fields: [
            {
              name: () => this.$t("agentName"),
              key: "agent_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("agentName");
              },
              options: [],
              disabled: true,
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAirAgent", {
                      id: that.row.id,
                      type: 3
                    })
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("expense"),
              key: "expense_item",
              component: "Select",
              disabled: true,
              placeholder: () => this.$t("select") + this.$t("expense"),
              options: [],
              config: { label: "name", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getExpense")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("cost_item_txt"),
              key: "cost_item",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("cost_item_txt"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCostItem")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("deliver_address"),
              key: "deliver_address",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("deliver_address"),
              bind: {
                multiple: true
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getDeliverAddress")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("currencyCode"),
              key: "currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("currencyCode"),
              options: [],
              disabled: true,
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change"({ formData }) {
                  formData.cny_cost = 0;
                  formData.cost = 0;
                  formData.to_cny_rate = 0;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("cost"),
              key: "amount",
              component: "InputNumber",
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%"
                }
              },
              disabled: true,
              default: 0,
              methods: {
                "on-change"({ formData }) {
                  formData.cny_cost =
                    formData.currency == "CNY"
                      ? formData.cost
                      : parseFloat(
                          (formData.cost * formData.to_cny_rate).toFixed(4)
                        );
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("turn") + this.$t("to_rmb") + this.$t("rate"),
              key: "to_cny_rate",
              component: "InputNumber",
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%"
                }
              },
              default: 0,
              show({ formData }) {
                return formData.currency && formData.currency != "CNY";
              },
              methods: {
                "on-change"({ formData }) {
                  formData.cny_cost =
                    formData.currency == "CNY"
                      ? formData.cost
                      : parseFloat(
                          (formData.cost * formData.to_cny_rate).toFixed(4)
                        );
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => "CNY" + this.$t("reChAmount"),
              key: "cny_amount",
              component: "InputNumber",
              disabled: true,
              bind: {
                disabled: true,
                style: {
                  width: "100%"
                }
              },
              default: 0
            },
            {
              name: () => this.$t("share_type_txt"),
              key: "share_type",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("share_type_txt"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getShareType")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            }
          ]
        }
      },
      footer: {
        show: () => true,
        render: h => {
          return h(
            "div",
            {
              class: "footer-content"
            },
            this.totalAmount.map(item => {
              return h(
                "div",
                {
                  class: "footer-content-item"
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title"
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  )
                ]
              );
            })
          );
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("add"),
            //   type: "add",
            //   fnName: "add",
            //   bind: {
            //     icon: "md-add",
            //     type: "warning"
            //   },
            //   id: 552
            // },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            // 导出
            export() {
              this.exportExc();
            }
            // // 新增
            // add() {
            //   this.getModal("add").open({}, function() {
            //     this.setTitle(this.$t("add"));
            //   });
            // }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name"
        },
        {
          name: () => this.$t("expense"),
          key: "expense_item_txt"
        },
        {
          name: () => this.$t("cost_item_txt"),
          key: "cost_item_txt"
        },
        {
          name: () => this.$t("deliver_address"),
          key: "deliver_address_txt"
        },
        {
          name: () => this.$t("share_type_txt"),
          key: "share_type_txt"
        },
        {
          name: () => this.$t("currencyCode"),
          key: "currency"
        },
        {
          name: () => this.$t("cost"),
          key: "amount",
          width: 100
        },
        {
          name: () => this.$t("turn") + this.$t("to_rmb") + this.$t("rate"),
          key: "to_cny_rate"
        },
        {
          name: () => "CNY" + this.$t("reChAmount"),
          key: "cny_amount"
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name"
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 120,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 551
            }
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete",
            //   id: 550
            // }
          ],
          methods: {
            update({ row }) {
              this.getModal("add").open(row, function() {
                this.setTitle(this.$t("update"));
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    this.$refs["table"].$main = this;

    //   console.log(this.row);
    //   let data = (await getConfig()).data.payload;
    //   let data1 = (await getAllClient()).data.payload.rows;
    //   this.header.searchs.forEach(item => {
    //     if (item.key === "time_type") item.options = data.time_type;
    //     if (item.key === "bill_status")
    //       item.options = Object.keys(data.bill_status).map(item => ({
    //         value: item,
    //         label: data.bill_status[item]
    //       }));
    //     if (item.key === "client_agent_id") item.options = data1;
    //   });
  }
};
</script>
